import React, { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Download, FileText, CheckCircle2 } from "lucide-react";
import { api, API } from "@/lib/api";
import { attribution, track } from "@/lib/analytics";

export const LeadMagnet = ({ compact = false }) => {
  const [form, setForm] = useState({ first_name: "", email: "", privacy_consent: false });
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.first_name || !form.email) return toast.error("Inserisci nome ed email.");
    if (!form.privacy_consent) return toast.error("È necessario accettare la privacy policy.");
    setLoading(true);
    try {
      await api.post("/lead-magnet", { ...form, phone: "", lead_type: "lead_magnet", requested_action: "brochure", ...attribution() });
      track("lead_form_submit", { form: "lead_magnet" });
      setDone(true);
      toast.success("Grazie! La tua guida è pronta.");
    } catch { toast.error("Errore. Riprova."); }
    finally { setLoading(false); }
  };

  const download = () => {
    track("brochure_download", { source: "lead_magnet" });
    window.open(`${API}/brochure/download`, "_blank");
  };

  return (
    <div className={`rounded-3xl border border-emerald-200 ${compact ? "p-6" : "p-8"}`} style={{ background: "var(--sc-emerald-light)" }} data-testid="lead-magnet">
      <div className="flex items-center gap-3 mb-3">
        <span className="w-12 h-12 rounded-xl flex items-center justify-center text-white shrink-0" style={{ backgroundColor: "var(--sc-emerald)" }}><FileText size={24} /></span>
        <div>
          <h3 className="text-xl font-bold text-slate-900 leading-tight" style={{ fontFamily: "Outfit" }}>Guida gratuita alla mobilità per senior</h3>
          <p className="text-slate-600 text-sm">PDF con tutto ciò che serve per scegliere con serenità.</p>
        </div>
      </div>

      {done ? (
        <div className="text-center py-4" data-testid="lead-magnet-success">
          <CheckCircle2 className="mx-auto text-emerald-700 mb-2" size={40} />
          <p className="font-semibold text-emerald-900 mb-4">La tua guida è pronta!</p>
          <Button onClick={download} className="h-12 px-6 font-bold text-white rounded-full gap-2" style={{ backgroundColor: "var(--sc-amber)" }} data-testid="brochure-download-button">
            <Download size={18} /> Scarica la guida (PDF)
          </Button>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-3">
          <Input placeholder="Nome" value={form.first_name} onChange={(e) => setForm({ ...form, first_name: e.target.value })} className="h-12 bg-white" data-testid="lm-name" />
          <Input type="email" placeholder="La tua email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="h-12 bg-white" data-testid="lm-email" />
          <label className="flex items-start gap-2 text-sm text-slate-600">
            <Checkbox checked={form.privacy_consent} onCheckedChange={(v) => setForm({ ...form, privacy_consent: !!v })} className="mt-0.5" data-testid="lm-privacy" />
            <span>Ho letto e accetto la <a href="/privacy" className="underline">Privacy Policy</a>.</span>
          </label>
          <Button type="submit" disabled={loading} className="w-full h-12 font-bold text-white rounded-full gap-2" style={{ backgroundColor: "var(--sc-emerald)" }} data-testid="lm-submit">
            <Download size={18} /> {loading ? "Invio..." : "Ricevi la guida gratuita"}
          </Button>
        </form>
      )}
    </div>
  );
};
